import React, { useEffect, useState, useRef, useMemo } from "react";
import { studentPropList } from "../user.api";
import Loader from "../../../components/loader/loader";
import { data } from "../../../layout/userlayout/components/footer/heatmap";
import TechPropTile from "../technology_proposal/components/techPropTile";
import "./style.css";
import Pagination from "../../../components/page/companyDirectory/companyPagination";
import BreadCrumpBack from "../../../components/navigator/back";
let PageSize = 10;
export default function BusinessProposal(props) {
  const [isActive, setIsActive] = useState(false);
  const myRef = useRef(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [proposalData, setProposalData] = useState([]);

  const getData = () => {
    setIsActive(true);
    studentPropList().then((res) => {
      let tdata = res.data;

      tdata = tdata
        .map((item) => {
          item["project_proposal_title"] = item.project_title;
          item["short_details_proposal"] = item.short_proposal_details;
          return item;
        })
        .filter((item) => item.status === 2);

      setProposalData(tdata);
      setIsActive(false);
    });
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
    myRef.current.scrollIntoView();
  };

  const currentPageData = useMemo(() => {
    const firstPageIndex = (currentPage - 1) * PageSize;
    const lastPageIndex = firstPageIndex + PageSize;
    return proposalData.slice(firstPageIndex, lastPageIndex);
  }, [proposalData, currentPage]);
  useEffect(() => {
    getData();
  }, []);

  return (
    <div ref={myRef}>
      <div className="">
        <Loader open={isActive} />
        <div>
          <div className="header-banner">
            <div className="tit-txt">
              {props.state.language === "ma"
                ? "വിദ്യാർത്ഥി നിർദ്ദേശങ്ങൾ"
                : "Student Proposals"}
            </div>
          </div>
           <BreadCrumpBack />
          <div className="container">
            <div className="proposal-tiles-container">
              {proposalData.length > 0 ? (
                <>
                  {currentPageData.map((item) => (
                    <TechPropTile key={item.id} data={item} {...props} />
                  ))}

                  <Pagination
                    className="pagination-bar"
                    currentPage={currentPage}
                    totalCount={proposalData.length}
                    pageSize={PageSize}
                    onPageChange={(page) => handlePageChange(page)}
                  />
                </>
              ) : (
                <>
                  <div className="no-data">
                    <img src="resources/img/no1.png" alt="" />
                    <h4>No Records Found..!!</h4>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
